import { HiX } from "react-icons/hi";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useState, useEffect } from "react";
import logo from 'components/sidebar/logo3.png';
import Cardmenu from "components/sidebar/componentsrtl/Cardmenu";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const { open, onClose } = props;
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsOpen(false); // Colapsar sidebar en dispositivos móviles
      } else {
        setIsOpen(true); // Expandir sidebar en pantallas grandes
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Inicializa el estado

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      className={`fixed z-50 flex min-h-full flex-col bg-blueSecondary pb-10 shadow-2xl transition-all dark:bg-navy-100 dark:text-white ${
        isOpen ? "translate-x-0 w-64" : "w-20"
      }`}
    >
      {/* Botón de cierre */}
      <button
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </button>

      {/* Logo */}
      <div className={`mx-[46px] mt-[30px] flex items-center text-white ${!isOpen && 'hidden'}`}>
        <img src={logo} alt="Logotipo" className="w-[180px] h-[180px] mr-2" />
      </div>

      {/* Separador */}
      <div className="mt-[18px] mb-2 h-px bg-gray-500 dark:bg-white/80" />

      {/* Contenido */}
      <div className="flex justify-center bg-blueSecondary p-4">
        <Cardmenu isOpen={isOpen} />
      </div>

      {/* Botón para colapsar */}
      <button
        className="absolute text-white bg-gray-900 cursor-pointer -right-5 top-10 w-9 h-9 border-dark-purple border-2 rounded-full"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaAngleLeft size={24} /> : <FaAngleRight size={24} />}
      </button>
    </div>
  );
};

export default Sidebar;
